import { initializeApp } from 'firebase/app';
import { getAnalytics, logEvent } from 'firebase/analytics';

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCUMDyJfYhdNqiWL11147higgoSl8kmjxs",
  authDomain: "twincalculator-86963.firebaseapp.com",
  projectId: "twincalculator-86963",
  storageBucket: "twincalculator-86963.firebasestorage.app",
  messagingSenderId: "378242405967",
  appId: "1:378242405967:web:de6d0f95a2c75d77b23c3a",
  measurementId: "G-1KVP8Q79RT"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

// Function to log page views
export const logPageView = (pageName, pageLocation, pagePath) => {
  try {
    logEvent(analytics, 'page_view', {
      page_title: pageName,
      page_location: pageLocation || window.location.href,
      page_path: pagePath || window.location.pathname
    });
  } catch (error) {
    console.error('Analytics error:', error);
  }
};

// Function to log events
export const logAnalyticsEvent = (eventName, eventParams = {}) => {
  try {
    logEvent(analytics, eventName, eventParams);
  } catch (error) {
    console.error('Analytics error:', error);
  }
};

// Function to log calculator usage
export const logCalculatorUse = (calculatorName, additionalParams = {}) => {
  try {
    logEvent(analytics, 'calculator_use', {
      calculator_name: calculatorName,
      ...additionalParams
    });
  } catch (error) {
    console.error('Analytics error:', error);
  }
};

export default {
  app,
  analytics,
  logPageView,
  logAnalyticsEvent,
  logCalculatorUse
};